import { Injectable, inject } from '@angular/core';

import { STATE_PORT } from '../utils';

/**
 * Thin seam around reading the current ui-router state params in the hybrid
 * app.
 *
 * Reads from the AngularJS `$state` service (bridged via {@link STATE_PORT})
 * rather than reaching into `window.angular` from components, which keeps
 * callers unit-testable: specs provide a fake STATE_PORT without booting
 * AngularJS / ui-router.
 */
@Injectable({ providedIn: 'root' })
export class RouteParamsService {
  private readonly state = inject(STATE_PORT);

  /**
   * Read a single param from the current ui-router state. Returns `null` when
   * the param is absent or empty.
   */
  get(name: string): string | null {
    const value = this.state.params?.[name];
    return typeof value === 'string' && value.length > 0 ? value : null;
  }
}
